const $ = require('jquery')

module.exports = (function () {
  function setFormCsrfToken () {
    let tmpl

    const token = getCsrfToken()

    if (token) {
      tmpl = '<input name="_csrf" value="' + token + '" type="hidden" />'
      $('form').prepend(tmpl)
    }
  }

  function getCsrfToken () {
    return $('meta[name=csrf-token]').attr('content')
  }

  function setCsrfToken (token) {
    $('form input[name="_csrf"]').val(token)
    $('meta[name=csrf-token]').attr('content', token)
  }

  return {
    setFormCsrfToken: setFormCsrfToken,
    getCsrfToken: getCsrfToken,
    setCsrfToken: setCsrfToken
  }
})()
